import { render, staticRenderFns } from "./Maintainers.vue?vue&type=template&id=1139d409&"
import script from "./Maintainers.vue?vue&type=script&lang=ts&"
export * from "./Maintainers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports